import { Flex, IconButton, useBreakpointValue } from "@chakra-ui/react";
import logoComTexto from "../../assets/logo-interbrasil.webp";
import { Icon } from "@chakra-ui/react";
import { BiExit } from "react-icons/bi";
import { Link } from "react-router-dom";
import { RiMenuLine } from "react-icons/ri";
import { useSidebarDrawer } from "contexts/SidebarDrawerContext";
import { useAuth } from "hooks/useAuth";

const Header = () => {
  const { signOut } = useAuth();
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const { onOpen } = useSidebarDrawer();

  return (
    <Flex
      bgColor={"blue.200"}
      alignItems="center"
      height="72px"
      paddingInline="4"
    >
      {!isWideVersion && (
        <IconButton
          aria-label="Open navigation"
          icon={<Icon as={RiMenuLine} color="white" />}
          fontSize="24"
          variant="unstyled"
          onClick={onOpen}
          mr="auto"
        />
      )}
      <Link to="/">
        <img src={logoComTexto} alt="Logo Interbrasil" />
      </Link>
      <IconButton
        aria-label="Sair"
        onClick={() => {
          signOut();
        }}
        size="sm"
        fontSize="sm"
        colorScheme="none"
        marginLeft="auto"
        cursor="pointer"
        icon={<Icon as={BiExit} fontSize="24" />}
      />
    </Flex>
  );
};

export default Header;
